<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('manage')}} {{t('vulnerability')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Assessments')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/vulnerability/assessments" class="d-inline-block position-relative">
                    {{t('Management')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/vulnerability/view-vulnerabilities/{{vulnerabilityAssessmentId}}"
                    class="d-inline-block position-relative">
                    {{t('Vulnerabilities')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('manage')}} {{t('vulnerability')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Manage Vulnerability -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('Management')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
            <mat-card-title>
                @if (vulnerabilityAssessment) {
                {{vulnerabilityAssessment.branchOffice.company.name}} - {{vulnerabilityAssessment.assessmentName}}
                }
            </mat-card-title>
            @if (roleName == internal || roleName == specialist) {
            <mat-card-subtitle>
                <button mat-flat-button class="altair" (click)="toggleClass()">
                    {{t('add-new-management')}}
                </button>
            </mat-card-subtitle>
            }
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="task" matSortDisableClear
                        matSortDirection="asc">

                        <!-- Task Column -->
                        <ng-container matColumnDef="task">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('task')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <textarea matInput type="text" readonly="true" class="textarea-input" [value]="row.task"></textarea>
                            </td>
                        </ng-container>

                        <!-- Note Column -->
                        <ng-container matColumnDef="note">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('note')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <textarea matInput type="text" readonly="true" class="textarea-input" [value]="row.note"></textarea>
                            </td>
                        </ng-container>

                        <!-- Tracking Creation Date Column -->
                        <ng-container matColumnDef="trackingCreationDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('trackingCreationDate')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{(row.trackingCreationDate ? row.trackingCreationDate.substring(0, 10) : '')}}
                            </td>
                        </ng-container>

                        <!-- Start Contract Column -->
                        <ng-container matColumnDef="trackingResolutionDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('trackingResolutionDate')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{(row.trackingResolutionDate ? row.trackingResolutionDate.substring(0, 10) : '')}}
                            </td>
                        </ng-container>

                        <!-- Task Type Column -->
                        <ng-container matColumnDef="taskType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('type')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.taskType}}
                            </td>
                        </ng-container>

                        <!-- Assigned User Name Column -->
                        <ng-container matColumnDef="assignedUserName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('user')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.assignedUserName}}
                            </td>
                        </ng-container>

                        <!-- File Column -->
                        <ng-container matColumnDef="file">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('file')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.evidenceFile) {
                                    <a mat-button href="{{row.evidence}}" target="_blank"
                                    matTooltip="{{t('view')}} {{t('evidence')}}" matTooltipPosition="above">
                                    <img src="assets/images/icons/{{cleanFileName(row.evidenceFile).extension.toLowerCase()}}.png"
                                        width="20%" height="20%" alt="{{cleanFileName(row.evidenceFile).extension}}">
                                    {{cleanFileName(row.evidenceFile).cleanedName}}
                                </a>
                                }
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-info">
                                    <mat-checkbox class="info" [checked]="row.state" (click)="onClick(row.id)"
                                        [disabled]="roleName == supervisor || roleName == manager"
                                        matTooltip="{{t('change')}} {{t('state')}}"></mat-checkbox>
                                    @if (roleName == internal || roleName == specialist) {
                                    <button type="button" mat-button (click)="edit(row.id)"
                                        matTooltip="{{t('edit')}} {{t('Management')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            edit
                                        </i>
                                    </button>
                                    <button type="button" mat-button (click)="delete(row.id)"
                                        matTooltip="{{t('delete')}} {{t('Management')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            delete
                                        </i>
                                    </button>
                                    }
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [length]="totalItems" [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Popup -->
    <div class="add-new-management-popup" [class.active]="classApplied"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <div class="popup-dialog">
            <mat-card class="altair-card mb-25 border-radius bg-white border-none d-block">
                <mat-card-header>
                    <mat-card-title>
                        <h5 class="mt-0 mb-0">
                            @if (!vulnerabilityTrackingId) {
                            {{t('add')}} {{t('Management')}}
                            } @else {
                            {{t('edit')}} {{t('Management')}}
                            }
                        </h5>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <button mat-button (click)="toggleClass()">
                            <i class="ri-close-fill"></i>
                        </button>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="vulnerabilityTrackingForm">
                        <div class="row">
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('task')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-task')}}
                                    </mat-label>
                                    <input matInput id="task" formControlName="task" required>
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('note')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-note')}}
                                    </mat-label>
                                    <input matInput id="note" formControlName="note">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('task-type')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('select-task-type')}}
                                    </mat-label>
                                    <mat-select formControlName="taskType">
                                        <mat-option *ngFor="let type of taskTypes" [value]="type">
                                            {{type}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="ccol-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('trackingCreationDate')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('choose-a-date')}}
                                    </mat-label>
                                    <input matInput [matDatepicker]="tcd" formControlName="trackingCreationDate">
                                    <mat-hint>DD/MM/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix [for]="tcd"></mat-datepicker-toggle>
                                    <mat-datepicker #tcd disabled="false"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="ccol-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('trackingResolutionDate')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('choose-a-date')}}
                                    </mat-label>
                                    <input matInput [matDatepicker]="trd" formControlName="trackingResolutionDate">
                                    <mat-hint>DD/MM/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix [for]="trd"></mat-datepicker-toggle>
                                    <mat-datepicker #trd disabled="false"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            @if(!vulnerabilityTrackingId) {
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('upload-file')}}
                                </label>
                                <file-upload class="file-uploader" multiple="false" accept=".gif,.jpg,.png,.zip,.pdf"
                                    formControlName="file"></file-upload>
                            </div>
                            }
                        </div>
                        <div class="btn-box">
                            <button mat-button type="button" (click)="!vulnerabilityTrackingId ? addVulnerabilityTracking() : editVulnerabilityTracking()"
                                [disabled]="vulnerabilityTrackingForm.invalid || isWorking">
                                {{t('save')}} {{t('Management')}}
                            </button>
                            <button mat-button (click)="toggleClass()">
                                {{t('cancel')}}
                            </button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

</ng-container>
